var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRestoreFromTrashFill = function SvgRestoreFromTrashFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19V6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 5q0-.424.287-.713A.97.97 0 0 1 5 4h4q0-.424.287-.712A.97.97 0 0 1 10 3h4q.424 0 .713.288Q15 3.575 15 4h4q.424 0 .712.287Q20 4.576 20 5q0 .424-.288.713A.97.97 0 0 1 19 6v13q0 .824-.587 1.413A1.93 1.93 0 0 1 17 21zm4-9.15V15q0 .424.287.713.288.287.713.287.424 0 .713-.287A.97.97 0 0 0 13 15v-3.15l.9.875a.93.93 0 0 0 .688.275q.412 0 .712-.3a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7l-2.6-2.6a.96.96 0 0 0-.7-.3q-.4 0-.7.3l-2.6 2.6a.98.98 0 0 0-.287.688.93.93 0 0 0 .287.712q.275.275.688.288a.97.97 0 0 0 .712-.263z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRestoreFromTrashFill);
export { ForwardRef as ReactComponent };